import { type CsvDelimiter, parseCSVLine } from './csvLineParser';

export type { CsvDelimiter };

export class AmbiguousCsvDelimiterError extends Error {
  constructor() {
    super(
      'Ambiguous CSV delimiter — quote fields or use a consistent separator',
    );
    this.name = 'AmbiguousCsvDelimiterError';
  }
}

const CANDIDATES: readonly CsvDelimiter[] = [',', ';'];

/** Detect whether comma or semicolon separates columns in the CSV file. */
export const detectCsvDelimiter = (
  lines: string[],
  expectedColumnCount: number,
): CsvDelimiter => {
  const matching = CANDIDATES.filter((delimiter) =>
    lines.every(
      (line) => parseCSVLine(line, delimiter).length === expectedColumnCount,
    ),
  );

  if (matching.length === 0) {
    throw new Error(
      `Could not detect CSV delimiter for ${expectedColumnCount} columns`,
    );
  }
  if (matching.length === 1) {
    return matching[0]!;
  }
  throw new AmbiguousCsvDelimiterError();
};
